import React from 'react';
import classnames from 'classnames';
import { useAppSelector } from '../../slices/commonSelectors';

type LoaderProps = {
  showLoading?: boolean;
  classes?: string;
  fullscreen?: boolean;
};

export default function Loader({
  showLoading = false,
  classes = '',
  fullscreen = true,
}: LoaderProps) {
  const isLoading = useAppSelector((state) => state.loading.isLoading);
  return isLoading || showLoading ? (
    <div
      className={classnames('loader', classes, {
        'zIndex--1': !fullscreen,
      })}
    >
      <div className="inner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  ) : null;
}
